import { render, staticRenderFns } from "./ModalConfirmationSupprEtab.vue?vue&type=template&id=3dd167d2"
import script from "./ModalConfirmationSupprEtab.vue?vue&type=script&lang=js"
export * from "./ModalConfirmationSupprEtab.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirmationSupprEtab.vue?vue&type=style&index=0&id=3dd167d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports